import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useState } from "react";
import { searchByProp } from "utils/search";
import SearchBar from "../base/SearchBar";

const FETCH_ODOO_PRODUCTS = gql`
  query FETCH_ODOO_PRODUCTS($instance: String!, $fields: [String]) {
    odooProducts(instance: $instance, fields: $fields)
  }
`;

const OdooProductSelector = ({
  instance = "AB",
  initialSearchText = "",
  onSelect,
}) => {
  const [searchText, setSearchText] = useState(initialSearchText);
  const { loading, error, data } = useQuery(FETCH_ODOO_PRODUCTS, {
    variables: { instance, fields: ["id", "name", "default_code", "barcode"] },
  });

  if (loading) return <Spinner text="Loading from Odoo.." />;
  if (error) return <Errors error={error} />;

  const odooProducts = JSON.parse(data.odooProducts);

  return (
    <div className="flex flex-col flex-1 text-sm">
      <SearchBar
        className="py-2 dark:bg-gray-900"
        autoFocus
        type="text"
        placeholder="Search by name or number"
        initialQuery={initialSearchText}
        value={searchText}
        onChange={setSearchText}
      />
      <div className="flex-1 mt-4">
        {odooProducts
          .filter((i) => searchByProp(i, ["name", "default_code"], searchText))
          .map((product) => (
            <div
              className="px-2 cursor-pointer border-b dark:border-gray-700 py-2 hover:bg-gray-100 active:bg-gray-200 flex justify-between"
              key={product.id}
              onClick={() => onSelect(product.id)}
            >
              <div>
                #{product.id} [{product.default_code}] {product.name}
              </div>
              <div>{product.barcode !== "false" ? product.barcode : null}</div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default OdooProductSelector;
